import { memo } from 'react';

import styles from './KnmActEventItemBodyProtocolsStudiedDocuments.module.scss';
import { useKnmDocumentAttachment } from '../../../MainModule/hooks/useKnmDocumentAttachment';
import { IKnmFormAttachment } from '../../../MainModule/interfaces/IKnmFormAttachment';
import { Row } from '../../../../UIPackage/FormModule/components/Row';
import { FieldBlock } from '../../../../UIPackage/FormModule/components/FieldBlock';
import { UploadFile } from '../../../../UIPackage/MainModule/components/UploadFile';

interface IErknmActEventItemBodyProtocolsStudiedDocumentsDocumentProps {
  files: IKnmFormAttachment[];
  name: string;
}

export const KnmActEventItemBodyProtocolsStudiedDocumentsDocument = memo(
  ({ files, name }: IErknmActEventItemBodyProtocolsStudiedDocumentsDocumentProps) => {
    const { downloadKnmDocumentAttachment } = useKnmDocumentAttachment();
    const downloadAttachment = (attachment: IKnmFormAttachment) => () => {
      const { fileName, fileSize } = attachment;
      const filePath = attachment.filePath || null;
      const mimeType = attachment.mimeType || null;

      downloadKnmDocumentAttachment({ fileName, filePath, fileSize, mimeType });
    };

    return (
      <div className={styles.ActDocument}>
        <div className="shared-group-label">
          Файл&nbsp;
          <span className="shared-no-wrap-text">приложения</span>
        </div>
        <ul className={styles.AttachmentsList} style={{ width: `100%` }}>
          {files.map((fileValue, fileIndex) => {
            const attachmentsFieldName = `${name}[${fileIndex}]`;
            let progress: number | undefined;

            if (fileValue.isNew) {
              progress = fileValue?.dateCreate ? 100 : 0;
            }

            return (
              <li className={styles.Attachment} key={attachmentsFieldName}>
                <Row notWrap>
                  <FieldBlock size="half">
                    <UploadFile
                      fileName={fileValue?.fileName || ''}
                      fileSize={fileValue?.fileSize}
                      progress={progress}
                      onFileNameClick={!fileValue?.isNew && fileValue?.guid ? downloadAttachment(fileValue) : undefined}
                    />
                  </FieldBlock>
                </Row>
              </li>
            );
          })}
        </ul>
      </div>
    );
  },
);
